<template>
  <div class="app-content-wrapper">
    <div class="search-wrapper">
      <search-component ref="search" class="transaction-search" :search-condition="searchCondition"
        :hideFuzzySearch="true" :showMerchantSearch="true" router-name="/report/success-rate">
      </search-component>
    </div>
    <div class="table-wrapper">
      <custom-table ref="table" :table-set="tableCondition" :service-function="queryList"
        :first-parameters="firstParameters()" :isPaginationDisplay="false" :showMerchantNo="true"
        router-name="/report/success-rate">
      </custom-table>
    </div>
  </div>
</template>
<script>
import { getCardTypeList } from '@/api/common';
import CustomTable from '@/components/table/custom-table.vue';
import SearchComponent from '@/components/table/search-component.vue';
import { eventTrackManager } from '@/plugins/eventTrackManager';
import { initExhibitionTable, initSelectedData } from '@/utils/tools/constant';
import { formatDateDisplay } from '@/utils/tools/time';
import ReportService from '@/views/report/api/report';

export default {
  components: {
    SearchComponent,
    CustomTable,
  },
  data() {
    return {
      searchCondition: [
        {
          key: 'tradeDate',
          name: 'message.tableCommon.txnTime',
          defValue: formatDateDisplay(new Date(), 'yyyy-MM'),
          type: 'date',
          dateType: 'month',
          dateFormat: 'yyyy-MM',
          dateValueFormat: 'yyyy-MM',
          handleClick: () => {
            eventTrackManager.send({ e: 'successreport_txntime' });
          },
        },
        {
          key: 'currency',
          name: 'message.tableCommon.currency',
          // name: 'message.tableCommon.transaction_currency',
          defValue: 'ALL',
          type: 'select',
          titleToolTips: 'message.report.successCurrencyTooltip',
          titleToolTipsKey: 'successreport_currency_tooltip',
          options: [
            { value: 'ALL', description: this.$t('message.searchCommon.all') },
          ],
          customOptions: {
            label: 'description',
            value: 'value',
          },
          handleClick: () => {
            eventTrackManager.send({ e: 'successreport_currency' });
          },
        },
        {
          key: 'cardType',
          name: 'message.tableCommon.cardType',
          type: 'select',
          defValue: '',
          options: [],
          handleClick: () => {
            eventTrackManager.send({ e: 'successreport_paymethod' });
          },
        },
        // {
        //   key: 'txnCurrency',
        //   name: 'message.settlement.currency',
        //   type: 'select',
        //   defValue: 'ALL',
        //   customOptions: {
        //     label: 'description',
        //     value: 'value',
        //   },
        // },
      ],
      tableCondition: [
        {
          titleBar: { type: 'text', title: 'message.tableCommon.txnTime' },
          key: 'tradeDate',
          type: 'text',
        },
        // 当日成功订单金额
        {
          titleBar: {
            type: 'text',
            title: 'message.tableCommon.successfulAmountDay',
            // title: "message.tableCommon.daily_successful_transaction_amount",
          },
          key: 'successTradedAmount',
          type: 'text',
        },
        // 当日结算币种金额
        // {
        //   titleBar: {
        //     type: 'text',
        //     title: 'message.tableCommon.daily_settlement_currency_amount',
        //   },
        //   key: 'txnApplySuccAmt',
        //   type: 'text',
        // },
        {
          titleBar: {
            type: 'text',
            title: 'message.tableCommon.successfulCountDay',
          },
          key: 'successTradedTotal',
          type: 'text',
        },
        {
          titleBar: {
            type: 'text',
            title: 'message.tableCommon.successfulRateDay',
          },
          key: 'successTradedRate',
          type: 'text',
          textFunc: (row) =>
            `${(Number(row.successTradedRate) * 100).toFixed(2)}%`,
        },
      ],
    };
  },
  mounted() {
    this.getCurrencyList();
    getCardTypeList()
      .then((data) => {
        const cardTypeList = initSelectedData(data, 'cardType', 'cardType');
        if (this.$refs.search) {
          this.$refs.search.setSearchSelectOptions('cardType', cardTypeList);
        }
      })
      .catch(() => ({}));

    this.$nextTick(() => {
      const successReportCurrencyTooltipDom = document.querySelector('.successreport_currency_tooltip');
      successReportCurrencyTooltipDom.addEventListener('mouseenter', () => {
        eventTrackManager.send({ e: 'successreport_hover' });
      });
      // successReportCurrencyTooltipDom.addEventListener('mouseleave', () => {
      //   console.log('鼠标移出');
      // });
    });
  },
  methods: {
    queryList: async (params, parent) => {
      try {
        if (!params.tradeDate) {
          params.tradeDate = formatDateDisplay(new Date(), 'yyyy-MM');
          const query = { ...params, status: 1 };
          parent.$refs.search.sendQueryCriteria(query);
          // eslint-disable-next-line prefer-promise-reject-errors
          return Promise.reject('customerErrorHandler');
        }
        delete params.status;
        const list = await ReportService.successRateReport(params);
        return Promise.resolve(initExhibitionTable(list, true));
      } catch (error) {
        return Promise.reject(error);
      }
    },
    getCurrencyList() {
      ReportService.getReportCurrency({ type: 0 })
        .then((res) => {
          if (this.$refs.search) {
            this.$refs.search.setSearchSelectOptions(
              'currency',
              res.map((item) => ({
                description:
                  item.value === 'ALL'
                    ? this.$t('message.searchCommon.all')
                    : item.value,
                value: item.value,
              })),
            );
            // 结算币种下拉框数据源设置
            // this.$refs.search.setSearchSelectOptions(
            //   'txnCurrency',
            //   res.map((item) => ({
            //     description:
            //       item.value === 'ALL'
            //         ? this.$t('message.searchCommon.all')
            //         : item.value,
            //     value: item.value,
            //   })),
            // );
            const oldCurrency = this.$route.query.currency;
            let exist = false;
            if (oldCurrency) {
              for (let i = 0; i < res.length; i++) {
                if (res[i].value === oldCurrency) {
                  exist = true;
                  break;
                }
              }
            }
            if (!exist || !oldCurrency) {
              this.$refs.search.setInputValue('currency', 'ALL');
            } else {
              this.$refs.search.setInputValue('currency', oldCurrency);
            }
          }
        })
        .catch(() => { });
    },
    firstParameters: () => {
      return {
        tradeDate: formatDateDisplay(new Date(), 'yyyy-MM'),
        currency: 'ALL',
      };
    },
  },
};
</script>
<style lang="scss">
@import "@/styles/variables.scss";
</style>
